// @flow
import React, { useCallback, useMemo } from 'react';
import { DataFetcherContainer } from '@presentational/DataFetcherContainer';
import { shouldSkipDataFetching } from '@src/common-utils/utils';
import { useGetSPUserCommitPricingStatusViewQuery } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { useParams } from 'react-router-dom';
import { SPUserCommitPricingStatusContext } from '@streaming-projects/user-commit-details/contexts/SPUserCommitPricingStatusContext';

export const SPUserCommitPricingStatusContextProvider = ({ children }) => {
  const params = useParams();
  const dataFetchingArgs = useMemo(
    () => [{ ...params }, { skip: shouldSkipDataFetching(params) }],
    [params]
  );

  const dataFetchingFunction = useCallback(useGetSPUserCommitPricingStatusViewQuery, []);

  return (
    <DataFetcherContainer
      dataFetchingArgs={dataFetchingArgs}
      dataFetchingFunction={dataFetchingFunction}
    >
      {(data, _, refetch, isLoading, isFetching) => {
        const isPricingStatusLoading = isFetching || isLoading;
        return (
          <SPUserCommitPricingStatusContext.Provider
            value={{ data, refetch, isPricingStatusLoading }}
          >
            {children}
          </SPUserCommitPricingStatusContext.Provider>
        );
      }}
    </DataFetcherContainer>
  );
};
